import * as React from 'react';
import { connect } from 'react-redux';
import { setNewLifeBeneficiary } from "../../actions/lifePolicyActions";
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile } from '../../actions/profileActions';
import { LIFE_ADD_BENEFICIARY, LIFE_INSURANCE, LIFE_UPDATE_POLICY_PAYOUT } from "../../routes/routes";
import { AddBeneficiary } from "../Beneficiary/AddBeneficiary";

class LifeAddBeneficiary extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            beneficiary: {},
            beneficiaryForm: {},
            isInEdit: false,
        }
        
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    componentDidMount() {
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];
        const beneficiary = mainBenefit?.beneficiaries?.filter((beneficiary) => beneficiary.id === this.props.lifePolicy.policy.activeBeneficiaryId)[0];
        
        const beneficiaryForm = {
            'personalRelation': {
                value: '',
                type: 'select',
                label: 'Relationship to you',
                as: 'select',
                options: [
                    { name: 'Child', value: 'child' },
                    { name: 'Parent', value: 'parent' },
                    { name: 'Other', value: 'other' },
                    { name: 'Spouse', value: 'spouse' },
                ]
            },
            'name': {
                value: '',
                type: 'text',
                label: 'Name and surname',
            },
            'rsaIdNumber': {
                value: '',
                type: 'text',
                label: 'ID no.'
            },
            'email': {
                value: '',
                type: 'email',
                label: 'Email'
            },
            'phoneNumber': {
                value: '',
                type: 'text',
                label: 'Phone no.'
            }
        }
        
        this.setState({
            beneficiaryForm,
            beneficiary,
            selectedBenefit: mainBenefit,
        });
        this.props.dispatchHideProfile();
    }
    
    handleBack() {
        this.handleRedirect(LIFE_INSURANCE);
    }
    
    handleAddBeneficiary() {
        this.handleRedirect(LIFE_ADD_BENEFICIARY);
    }

    handleChange(key, val) {
        this.setState({
            beneficiaryForm: {
                ...this.state.beneficiaryForm,
                [key]: {
                    ...this.state.beneficiaryForm[key],
                    value: val
                },
            },
            beneficiary: {
                ...this.state.beneficiary,
                [key]: val,
            }
        });
    }
    
    async handleSave(beneficiary) {
        const beneficiaryToSave = {
            'personalRelation': this.state.beneficiaryForm['personalRelation'].value,
            'name': this.state.beneficiaryForm['name'].value,
            'rsaIdNumber': this.state.beneficiaryForm['rsaIdNumber'].value,
            'email': this.state.beneficiaryForm['email'].value,
            'phoneNumber': this.state.beneficiaryForm['phoneNumber'].value,
            'percentage': 5,
        };
        await this.props.dispatchSetNewBeneficiary(beneficiaryToSave);
        this.handleRedirect(LIFE_UPDATE_POLICY_PAYOUT);
    }
    
    public render() {

        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        return <>
            { mainBenefit &&
                <AddBeneficiary
                    beneficiary={this.state.beneficiary}
                    beneficiaryForm={this.state.beneficiaryForm}
                    emitHandleAddBeneficiary={this.handleAddBeneficiary}
                    emitHandleBack={this.handleBack}
                    emitHandleSave={this.handleSave}
                    emitHandleChange={this.handleChange}
                />
            }
        </>
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchSetNewBeneficiary: (beneficiary: any) => dispatch(setNewLifeBeneficiary(beneficiary)),
        dispatchAddBeneficiary: () => dispatch(),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeAddBeneficiary);